import React from 'react';
import { Box, Typography } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';

interface PSICityInfoProps {
  psiName: string;
  location: string;
}

export const PSICityInfo: React.FC<PSICityInfoProps> = ({ psiName, location }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {/* PSI Name */}
      <Typography
        component="span"
        variant="body2"
        color="text.secondary"
        sx={{
          fontSize: '0.75rem',
          fontWeight: 500,
        }}
      >
        {psiName}
      </Typography>

      {/* Location */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
        <PlaceIcon
          sx={{
            fontSize: 14,
            color: 'text.secondary',
          }}
        />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: '0.75rem', fontWeight: 400 }}
        >
          {location}
        </Typography>
      </Box>
    </Box>
  );
};
